const mobileHeadingTagMap = {
    h1: 'h1',
    h2: 'h1',
    h3: 'h2',
    h4: 'h2',
    h5: 'h3',
    h6: 'h3',
};
export const headingTag = (tag) => mobileHeadingTagMap[tag] || 'h3';
//# sourceMappingURL=headingTag.js.map